import {useCallback, useEffect, useState} from 'react'
import {
  Alert,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material'
import {Close} from '@mui/icons-material'
import checkinApi from '../../../services/api/checkin/checkinApi'
import HeaderTableCell from '../../../components/common/StyledComponents/HeaderTableCell'
import StyledTableRow from '../../../components/common/StyledComponents/StyledTableRow'

export default function ParticipationBySchool({checkInId, open, onClose}) {
  const [schools, setSchools] = useState([])
  const [loading, setLoading] = useState(false)
  const [loadFailed, setLoadFailed] = useState(false)

  const loadParticipation = useCallback(() => {
    setLoading(true)
    setLoadFailed(false)
    return checkinApi
      .getParticipationBySchool(checkInId)
      .then(response => setSchools(Array.isArray(response) ? response : []))
      .catch(error => {
        // A failed fetch used to be indistinguishable from a trust with no schools.
        console.error('Failed to load participation by school', error)
        setSchools([])
        setLoadFailed(true)
      })
      .finally(() => setLoading(false))
  }, [checkInId])

  useEffect(() => {
    if (open) loadParticipation()
  }, [open, loadParticipation])

  const renderBody = () => {
    if (loading)
      return (
        <>
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
        </>
      )

    if (loadFailed)
      return (
        <Alert
          severity="error"
          action={
            <Button color="inherit" size="small" onClick={loadParticipation}>
              Retry
            </Button>
          }
        >
          We could not load participation by school. Please try again.
        </Alert>
      )

    if (schools.length === 0)
      return <Alert severity="info">No schools have taken part yet.</Alert>

    return (
      <Table size="small">
        <TableHead>
          <TableRow>
            <HeaderTableCell>School</HeaderTableCell>
            <HeaderTableCell>Invited</HeaderTableCell>
            <HeaderTableCell>Submitted</HeaderTableCell>
            <HeaderTableCell>Participation</HeaderTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {schools.map(school => (
            <StyledTableRow key={school.schoolId}>
              <TableCell>{school.schoolName}</TableCell>
              <TableCell>{school.invited}</TableCell>
              <TableCell>{school.submitted}</TableCell>
              <TableCell>{school.percentage}%</TableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    )
  }

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>
        Participation by school
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{position: 'absolute', right: 8, top: 8}}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent>{renderBody()}</DialogContent>
    </Dialog>
  )
}
